import styled from 'styled-components'

const StyledConnectView = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  justify-content: center;
  align-items: center;

  .label {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
    color: ${({ theme }) => theme.color.gray[600]};

    svg {
      margin-right: 10px;
    }
  }
`

export default StyledConnectView
